import './EnhancedEventViewRemarks.scss';
import { useTranslation } from 'react-i18next';

const EnhancedEventViewRemarks = ({ pairingEvent }) => {

  const { t } = useTranslation();

  return (
    pairingEvent.pairingDetails?.remarks ?
    <div className="c-ev-remarks">
      <p className="remarks__lbl">
        {t('myBlockMonth.remarks')}
        <span className="remarks__value"> {pairingEvent?.pairingDetails?.remarks}</span >
      </p>
    </div>
    :<></>          
  )
}

export default EnhancedEventViewRemarks;
